import el from "@cypherpotato/el";
import { DateTimeLabel } from "./datetime-label";
import { MutedText } from "./text";

export function NotificationsWrapper(...children) {
    
    return el(".notifications-wrapper",
        children?.length && children || MutedText("No new notifications.")
    )
}

export function NotificationItem({ createdAt, subject, message, readAt }) {

    return el(".notifications-item",
        {
            classList: [
                readAt && "read"
            ]
        },
        el(".notification-item-title",
            el("span.item-title", subject),
            el("span.item-date", DateTimeLabel(createdAt)),
        ),
        el(".notification-item-body",
            ...(message || "").split(/(https:\/\/\S+)/g).filter(Boolean).map(part => part.startsWith("https://")
                ? el("a", part.replace(/[.,;)]$/, ""), {
                    href: part.replace(/[.,;)]$/, ""),
                    target: "_blank",
                    rel: "noopener noreferrer"
                })
                : part)
        )
    )
}